import { MoneyPipe } from '@shared/pipes/money.pipe';
import { listInvoicesForReconciliationQuery } from '@shared/services/gql.service';
import { Utils } from '@shared/utils/utils';

import { validateInvoiceExpenses } from './validate-invoice-expenses';
import { ChecklistInvoiceMonthlyQuickView } from '../models/quarter-close-checklist.model';

export function calculateInvoiceMonthlyQuickView(
  selectedQuarterMonth: string,
  ungroupedInvoices: listInvoicesForReconciliationQuery[],
  isPivoted: boolean
): ChecklistInvoiceMonthlyQuickView {
  // Default values
  const invoiceQuickView: ChecklistInvoiceMonthlyQuickView = {
    amountInvoiced: Utils.zeroHyphen,
    numberOfInvoices: Utils.zeroHyphen,
  };

  // Return default
  if (!selectedQuarterMonth || !ungroupedInvoices.length) {
    return invoiceQuickView;
  }

  let numberOfInvoices = 0;
  let amountInvoiced = 0;

  // Calculate invoice totals
  const selectedQuarterPeriod = selectedQuarterMonth.substring(0, 7);

  ungroupedInvoices.forEach((invoice) => {
    if (invoice.accrual_period?.substring(0, 7) !== selectedQuarterPeriod) {
      return;
    }

    const validatedInvoice = validateInvoiceExpenses(invoice.expense_amounts, isPivoted);

    const validInvoice = validatedInvoice[0];
    const invoiceTotal = validatedInvoice[1];

    if (!validInvoice) {
      return;
    }

    // Increase number of invoices
    numberOfInvoices = numberOfInvoices + 1;

    // Increase amount invoiced
    amountInvoiced = amountInvoiced + invoiceTotal;
  });

  // Return default
  if (!numberOfInvoices) {
    return invoiceQuickView;
  }

  invoiceQuickView.numberOfInvoices = numberOfInvoices.toString();
  invoiceQuickView.amountInvoiced = new MoneyPipe().transform(amountInvoiced) as string;

  return invoiceQuickView;
}
